export default function classNames(...names: string[]) {
  return Array.from(new Set<string>(names))
    .map((name) => name.replace(" ", "_"))
    .join(" ")
    .trim();
};
